// extracted by mini-css-extract-plugin
export default {"tooltip":"ER-z","arrow":"FR-z"};